module.exports = __webpack_public_path__ + "static/img/4.8d628ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/4.png
// module id = VhU/
// module chunks = 0